export const FORECAST_MODEL_COLORS: Readonly<Record<string, string>> = {
  ECMWF_OP: '#1063ED',
  ECMWF_ENS: '#F70F1B',
  GFS_OP: '#53B9EC',
  GFS_ENS: '#EE8031',
  GEM_OP: '#316E2F',
  GEM_ENS: '#704014',
  MF_ECMWF_OP: '#E660D5',
  MF_GFS_OP: '#CDB882',
  MF_ECMWF_ENS: '#A232A8',
  FE_ECMWF_ENS: '#A232A8',
  ECMWF_AIFS: '#316E2F',
  ECMWF_AIFS_ENS: '#777EC3',
  AG2: '#000000',
};
